module.exports = __webpack_public_path__ + "bdd3ea5f2a0e2d181542edfab53dea99.pdf";